<template>
  <div class="text-center">
    <v-snackbar
        v-model="visible"
        :multi-line="false"
        timeout="15000"
        :color="'#c49a28'"
        bottom
        right
        transition="slide-x-transition"
    >
      {{ '' }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="close"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "MessageBox",
  props: {
    show: Boolean,
    message: String,
    type: String, // success, warning or error
  },

  data: () => ({
    visible: false
  }),

  watch: {
    show: function (newVal) {
      if (newVal) {
        this.$toast.open({
          message: this.message,
          type: this.type,
          position: 'top-right'
        });
      }

    },
  },

  methods: {
    close() {
      // this.$props.show = false;
      this.$emit('close-message');
    },
    showNotification({type = 'success', message, timeout = 3000}) {
      this.color = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info'
      }[type] || 'default';

      // this.timeout = timeout;
      // this.message = message;
      // this.snackbar = true;

      this.$toast.open({
        message: message,
        type: type,
        position: 'bottom-left',
        duration: timeout,
        dismissible: true,
        pauseOnHover: true,
        
      });
    }
  },

  computed: {
    icon: function () {
      return (this.type === 'success') ? 'check-circle' : (this.type === 'error' ? 'alert-circle' : (this.type === 'info' ? "information" : 'alert'))
    }
  }
}
</script>

<style scoped>
* {
  color: white !important;
}
</style>
